module.exports = __webpack_public_path__ + "img/enterprise.96ea59ff.png";